import List from "@/components/list";

const Table = args => {
  const AccountTableConfig = [
    {
      label: "姓名",
      prop: "userName",
      width: '130',
    },
    {
      label: "达标学时",
      prop: "examCredit",
      width: '130',
    },
    {
      label: "已获学时",
      prop: "gainCredit",
      width: '130',
    },
    {
      label: `必修课完成情况（已完成/达标要求）`,
      prop: "compulsoryCourseStatus",
      width: '134',
      renderHeader: () => {
        return <div>
          <div>必修课完成情况</div>
          <div>（已完成/达标要求）</div>
        </div>
      }
    },
    {
      label: "班级结业完成情况（已完成/达标要求）",
      prop: "graduationCLassStatus",
      width: '134',
      renderHeader: () => {
        return <div>
          <div>班级结业完成情况</div>
          <div>（已完成/达标要求）</div>
        </div>
      }
    },
    {
      label: "是否达标",
      prop: "isFinish",
      width: '130',
    },
  ];

  return <List {...args} talbeCols={AccountTableConfig} />;
};

export default Table;
